<template>
  <div class="item-wrapper">
    <input
      type="checkbox"
      class="item-wrapper__checkbox"
      v-if="item.id && isMassEdit"
      v-model="isChecked"
    />
    <router-link
      class="items-container__item item"
      :class="{ 'add-new-item': item.isNewRoute }"
      :to="item.isNewRoute ? { name: 'add-permit' } : { name: 'permit', params: {id: item.id}}"
    >
      <div class="item__row item__title">
        <span title="name" v-if="!item.isNewRoute">
          <span v-if="isLandlord() && item.userName">{{ item.userName }} ({{ item.partnerName }})</span>
          <span v-else-if="isLandlord()">{{ item.partnerName }}</span>
          <span v-else>{{ item.userName }}</span>
        </span>
        <span v-if="!item.isNewRoute" title="vehicleReg">{{ item.vehicleReg }}</span>
        <span v-if="item.isNewRoute">{{ item.name }}</span>
      </div>
      <div class="item__statusbar" v-if="!item.isNewRoute">
        <span class="filling" style="width: 0%"></span>
      </div>
      <div class="item__row item__subtitle" v-if="!item.isNewRoute">
        <span>
          <span v-if="item.parkingCardNr">{{ $t('permits.card_nr') }}: {{ item.parkingCardNr }}</span>
        </span>
        <span>
          <span class="orange" title="issued" v-if="item.productName">{{ item.productName }}</span>
        </span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    isMassEdit: Boolean,
    onClickCheckbox: Function,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    isChecked() {
      this.onClickCheckbox(this.item.id, this.isChecked);
    },
  },
  updated() {
    this.isChecked = this.checked;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/permits/ListItemTemplate.vue